module.exports = __webpack_public_path__ + "static/img/2.4681f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/doublelift/2.png
// module id = JivA
// module chunks = 35